import formHelper from 'formhelper';
import $ from 'jquery';

formHelper.addRule({
  form: '#form-cart-payment-update-totals',
  status: {
    SUCCESS() {
      $('#cart-total').replaceWith(this.data.html);
      $('#cart-payment--form-round-up').toggle(!this.data.hasPaymentPlan);
      $('#cart-payment--form-payment-plans').toggle(!this.data.hasContribution);
    }
  }
});

formHelper.addRule({
  form: '#form-cart-zero-payment',
  status: {
    SUCCESS() {
      this.redirect('/cart/receipt/order-no-' + this.data.orderNo);
    }
  }
});
